const Pricing = {
  label: 'Pricing',
  url: '/pricing',
  heapClass: 'uk_topnav_pricing'
}

export default Pricing
